const openMailBox = () => {
  const recipient = 'Support.VolvoGPTs@volvo.com';
  const subject = encodeURIComponent('Volvo GPTs Report Issue');
  const body = encodeURIComponent(
    'Describe issue :\n\n\nScreenshot and/or Error message :'
  );
  window.location.href = `mailto:${recipient}?subject=${subject}&body=${body}`;
};

const downloadFileFromBlob = (data: Blob | null, filename: string) => {
  if (!data) return;
  const url = window.URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const documentTranslationUtils = {
  openMailBox,
  downloadFileFromBlob,
};
